import React, { Component } from 'react'
import GreenButton from '../misc/GreenButton'
import WhiteSnake from '../../assets/imgs/white-snake-small.png';
import Axios from 'axios';


export class AgeList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            link: undefined,
            ageGroups: []
        };
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    componentWillMount() {
        Axios.get(`http://web.wholechildapp.com/api/content`).then(res =>
            this.setState({
                ageGroups: res.data.data.ageGroups
            }))

    }

    handleFormSubmit = formSubmitEvent => {
        formSubmitEvent.preventDefault();
        this.props.handleChangeForced('link', this.state.link)
    };


    chooseCategory = link => () => {
        this.setState({ link });
    };

    render() {
        const { ageGroups, link } = this.state;

        let turnedOn = {
            visibility: 'hidden'
        }
        if (link) {
            turnedOn = {
                visibility: 'visible'
            }
        }
        return (
            <form onSubmit={this.handleFormSubmit}>
                <div className="ageList">
                    {ageGroups.map((category, index) => (
                        <button key={index} className={`ageListBtn__chooseage ${link === category.id ? 'ageListBtn__active_chooseage' : ''}`}
                            onClick={this.chooseCategory(category.id)}>
                            {category.name}
                        </button>
                    ))}
                </div>
                <div className="welcome-end">
                    <GreenButton
                        style={turnedOn}
                        continue={this.props.goTo}
                        name="BEGIN TEST"
                    />
                    <img className="mobile-snake" alt="white-snake" src={WhiteSnake} />
                </div>
            </form>
        )
    }
}

export default AgeList
